import DesktopScrollContainer from '../../common/DesktopScrollContainer/DesktopScrollContainer';
import MobileScrollContainer from '../../common/MobileScrollContainer';
import MapPOICard from '../MapPOICard/MapPOICard';

import type { InteractiveMapItem } from '@skyscanner-internal/landing-pages-shared-types/types-shared/InteractiveMapProps';

import STYLES from './InteractiveMapCarousel.module.scss';

type Props = {
  items: InteractiveMapItem[];
  onCarouselItemChange: (args: number) => void;
  onScrollComplete: (args: number) => void;
  preventComplete: boolean;
  selectedItem: number;
};

export default function InteractiveMapCarousel({
  items,
  onCarouselItemChange,
  onScrollComplete,
  preventComplete,
  selectedItem,
}: Props) {
  return (
    <div className={STYLES.InteractiveMapCarousel}>
      <div className={STYLES.Desktop}>
        <DesktopScrollContainer
          nextLabel="next"
          prevLabel="prev"
          navPosition="bottom"
          onScrollComplete={onScrollComplete}
          selectedItem={selectedItem}
          setVisibleIndexes={(indexes) => {
            onCarouselItemChange(indexes[0]);
          }}
          singleCardPerPage
        >
          {items.map((item, index) => (
            <div className={STYLES.Card} key={item.id}>
              <MapPOICard {...item} isSelected={selectedItem === index} />
            </div>
          ))}
        </DesktopScrollContainer>
      </div>
      <div className={STYLES.Mobile}>
        <MobileScrollContainer
          onScrollComplete={onScrollComplete}
          preventComplete={preventComplete}
          selectedItem={selectedItem}
          setVisibleIndex={onCarouselItemChange}
        >
          {items.map((item, index) => (
            <div className={STYLES.Card} key={item.id}>
              <MapPOICard {...item} isSelected={selectedItem === index} />
            </div>
          ))}
        </MobileScrollContainer>
      </div>
    </div>
  );
}
